export enum EmailLogStatus {
  UNASSIGNED = 0,
  FAILED = 1,
  DELIVERED = 2
}